<template>
  <div>
    <div class="md-form">
      <label class="active mr-5">Current Role</label>
      <select class="material-input form-control" name="role" v-model="member.role" v-on:change="roleChange()">
        <option value="Admin">Admin</option>
        <option value="Event Organizer">Event Organizer</option>
        <option value="Group Organizer">Group Organizer</option>
        <option value="Member">Member</option>
      </select>
    </div>
    <div v-if="member.role != 'Admin'">
      <h3>Additional Rights</h3>
      <div class="small">(Click or tap to toggle rights)</div>
      <div v-bind:key="i" v-for="(permission,i) in access">
        <span v-if="permission.enabled">
          <mdb-btn v-on:click="disablePerm(permission.name)">
            {{ permission.name }}
          </mdb-btn>
        </span>
        <span v-if="!permission.enabled">
          <mdb-btn color="disabled" v-on:click="enablePerm(permission.name)">
            {{ permission.name }}
          </mdb-btn>
        </span>
      </div>
    </div>
    <a href="/page/member-security" target="_blank">Learn about member access</a>

    <div v-if="member.role != 'Admin'">
      <h3>Private Messaging Rule Override</h3>
      <mdb-btn :color="(!communicationRuleOverride || communicationRuleOverride == 'WAIVE_WAITING_PERIOD') ? 'disabled' : 'default'" v-on:click="setCommunicationRule('PROHIBITED')">
        Prohibited
      </mdb-btn>
      <mdb-btn :color="(!communicationRuleOverride || communicationRuleOverride == 'PROHIBITED') ? 'disabled' : 'default'" v-on:click="setCommunicationRule('WAIVE_WAITING_PERIOD')">
        Allow Immediately
      </mdb-btn>
      <mdb-btn :color="!communicationRuleOverride ? 'default' : 'disabled' " v-on:click="setCommunicationRule(null)">
        No Override - Use Group Rules
      </mdb-btn>
    </div>

  </div>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {mdbBtn} from 'mdbvue';

export default {
  name: 'Member-Access',
  components: {
    mdbBtn
  },
  props: {
    member: {
      type: Object,
      default: null
    },
    group: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      access: null,
      communicationRuleOverride: null
    }
  },
  mounted() {
    this.$store.dispatch("setExecuting", true)
    api.get("/member/access/" + this.group.vanityPath + "/?member=" + this.member.id).then(
        (results) => {
          this.access = results.data.perms
          this.communicationRuleOverride = results.data.communicationRuleOverride
        },
        (error) => {
          this.$notify.error({message: "Error fetching data", timeOut: 5000})
        }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  methods: {
    roleChange: function () {
      this.$store.dispatch("setExecuting", false)
      api.post("/member/setRole/" + this.group.vanityPath + "/?member=" + this.member.id, {role: this.member.role}).then(
          (results) => {
          },
          (error) => {
            this.$notify.error({message: "Error saving data", timeOut: 5000})
          }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    enablePerm: function (perm) {
      this.$store.dispatch("setExecuting", true)
      api.post("/member/enablePerm/" + this.group.vanityPath + "/?member=" + this.member.id, {permission: perm}).then(
          (results) => {
            for (let i = 0; i < this.access.length; i++) {
              let a = this.access[i]
              if (a.name == perm) {
                a.enabled = true
              }
            }
          },
          (error) => {
            this.$notify.error({message: "Error saving data", timeOut: 5000})
          }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    setCommunicationRule: function (rule) {
      if (rule == this.communicationRuleOverride) return
      this.$store.dispatch("setExecuting", true)
      api.post("/member/communicationRule/" + this.group.vanityPath + "/?member=" + this.member.id, {rule: rule}).then(
          () => {
            this.communicationRuleOverride = rule
          },
          (error) => {
            this.$notify.error({message: "Error saving data", timeOut: 5000})
          }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    disablePerm: function (perm) {
      this.$store.dispatch("setExecuting", true)
      api.post("/member/disablePerm/" + this.group.vanityPath + "/?member=" + this.member.id, {permission: perm}).then(
          (results) => {
            for (let i = 0; i < this.access.length; i++) {
              let a = this.access[i]
              if (a.name == perm) {
                a.enabled = false
              }
            }
          },
          (error) => {
            this.$notify.error({message: "Error saving data", timeOut: 5000})
          }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};
</script>
<style scoped>
.material-input {
  box-sizing: content-box;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #ced4da;
  border-radious: 0;
  outline: none;
  box-shadow: none;
}
</style>
